import React from 'react';
import SectionTechSpecs from '../../section-tech-specs';

function StoryblokSystemsTechnicalInformationAdapter({ title, items }) {
  return <SectionTechSpecs title={title} data={items} />;
}

export default StoryblokSystemsTechnicalInformationAdapter;
